import { combineReducers } from 'redux';

import announcementsReducer from 'reducers/data/announcementsReducer';
import dashboardReducer from 'reducers/ui/dashboardReducer';
import defaultsReducer from 'reducers/ui/defaultsReducer';
import dropdownsReducer from 'reducers/ui/dropdownsReducer';
import filterReducer from 'reducers/ui/filterReducer';
import historyReducer from 'reducers/data/historyReducer';
import kdHistoryReducer from 'reducers/data/kdHistoryReducer';
import listsReducer from 'reducers/data/listsReducer';
import locationsReducer from 'reducers/data/locationsReducer';
import messagesReducer from 'reducers/ui/messagesReducer';
import miscReducer from 'reducers/ui/miscReducer';
import panelsReducer from 'reducers/ui/panelsReducer';
import paramsReducer from 'reducers/paramsReducer';
import resultsReducer from 'reducers/data/resultsReducer';
import serpResultsReducer from 'reducers/data/serpResultsReducer';
import trendsReducer from 'reducers/data/trendsReducer';
import userReducer from 'reducers/userReducer';
import currenciesReducer from 'reducers/data/currenciesReducer';
import serpwatcherTrackingsReducer from 'reducers/data/serpwatcherTrackingsReducer';
import competitorsReducer from 'reducers/data/competitorsReducer';
import keywordGapResultsReducer from 'reducers/data/keywordGapResultsReducer';
import urlDataReducer from 'reducers/urlDataReducer';
import comparingBoxReducer from 'reducers/ui/comparingBoxReducer';
import relativeKdReducer from 'reducers/ui/relativeKdReducer';
import searchIntentReducer from 'reducers/data/searchIntentReducer';
import contentTypesReducer from 'reducers/data/contentTypesReducer';
import serpsColumnsSettingsReducer from 'reducers/ui/serpsColumnsSettingsReducer';
import keywordsColumnsSettingsReducer from './ui/keywordsColumnsSettingsReducer';
import keywordGapColumnsSettingsReducer from './ui/keywordGapColumnsSettingsReducer';
import kwOpportunitiesReducer from './data/kwOpportunitiesReducer';
import serpFeaturesReducer from './data/serpFeaturesReducer';

const rootReducer = combineReducers({
    data: combineReducers({
        announcements: announcementsReducer,
        history: historyReducer,
        kdHistory: kdHistoryReducer,
        lists: listsReducer,
        contentTypes: contentTypesReducer,
        serpFeatures: serpFeaturesReducer,
        locations: locationsReducer,
        results: resultsReducer,
        serpResults: serpResultsReducer,
        trends: trendsReducer,
        currencies: currenciesReducer,
        serpwatcherTrackings: serpwatcherTrackingsReducer,
        competitors: competitorsReducer,
        keywordGapResults: keywordGapResultsReducer,
        searchIntent: searchIntentReducer,
        kwOpportunities: kwOpportunitiesReducer,
    }),
    params: paramsReducer,
    ui: combineReducers({
        dashboard: dashboardReducer,
        defaults: defaultsReducer,
        dropdowns: dropdownsReducer,
        filter: filterReducer,
        messages: messagesReducer,
        misc: miscReducer,
        panels: panelsReducer,
        comparingBox: comparingBoxReducer,
        relativeKd: relativeKdReducer,
        columnsSettings: combineReducers({
            serps: serpsColumnsSettingsReducer,
            keywords: keywordsColumnsSettingsReducer,
            keywordGap: keywordGapColumnsSettingsReducer,
        })
    }),
    user: userReducer,
    urlData: urlDataReducer,
});

export default rootReducer;
